// Momentele din hero: clipuri de ~2 s din trailer, derulate la scroll, cu un text după fiecare.
// Clipurile: assets/momente/NN.mp4 (1080p, desktop), assets/momente/m/NN.mp4 (720p, telefon), NN.jpg = primul cadru.
// Refacere din exporturile 4K (trailer/clipuri_site/): 30 fps, x264 CRF 22 / 23, keyframe la 10 cadre, fără B-frames, fără sunet.
const mp4 = import.meta.glob('./assets/momente/*.mp4', { eager: true, import: 'default' })
const mp4m = import.meta.glob('./assets/momente/m/*.mp4', { eager: true, import: 'default' })
const jpg = import.meta.glob('./assets/momente/*.jpg', { eager: true, import: 'default' })

const TEXTE = [
    { titlu: 'Vinewood Grand', text: 'Prima noapte în oraș începe la recepție. Nouă etaje de camere și, deasupra lor, un singur penthouse. Cine îl cumpără, îl păstrează.' },
    { titlu: 'Jafuri', text: 'Banii din sertar sunt ai tăi. Alarma a pornit deja, iar poliția e pe drum.' },
    { titlu: 'Fuga', text: 'De urmărire poți scăpa. De cazier, nu. Fiecare faptă rămâne la dosar, iar orice polițist ți-l deschide din MDT.' },
    { titlu: 'Vinewood Police Department', text: 'VPD. Patrulează tot orașul, zi și noapte.' },
    { titlu: 'Mașini custom', text: 'Mașini noi, fără sigle reale. Le găsești la Premium Deluxe Motorsport sau la casa de licitații.' },
    { titlu: 'Curse', text: 'Lobby, ture și mașina aleasă înainte de start. Pe unele trasee pleci pe roți și continui în aer.' },
    { titlu: 'Premium Deluxe Motorsport', text: 'Plătești în showroom, iar mașina nouă iese pe ușa garajului cu tine la volan, noaptea, pe ploaie, filmată ca într-o reclamă.' },
    { titlu: 'Casa de licitații', text: 'Vineri, sâmbătă și duminică seara, sala se umple. Mașini rare, case și afaceri ale jucătorilor se vând live, la cine dă mai mult.' },
    { titlu: 'Cinema drive-in', text: 'Parchezi în fața ecranului de lângă universitate. Programul e al orașului, dar la cabină îți poți cumpăra locul pentru filmul tău.' },
    { titlu: 'Vinewood Store', text: 'Haine Vinewood care nu se vând nicăieri altundeva în oraș. Le probezi în cabină, în fața oglinzii, și ieși îmbrăcat din colecția nouă.' },
    { final: true }, // semnul Vinewood: doar butonul de Discord
]

const nr = (i) => String(i + 1).padStart(2, '0')

export const MOMENTE = TEXTE.map((t, i) => ({
    ...t,
    src: mp4[`./assets/momente/${nr(i)}.mp4`],
    srcMobil: mp4m[`./assets/momente/m/${nr(i)}.mp4`],
    poster: jpg[`./assets/momente/${nr(i)}.jpg`],
}))
